import { observable, action } from 'mobx';

class RouterStore {
  @observable
  history = null;

  @observable
  location = null;

  @action
  updateLocation(newState) {
    this.location = newState;
  }

  @action
  push = (location, state) => {
    this.history.push(location, state);
  };

  @action
  replace = (location, state) => {
    this.history.replace(location, state);
  };

  @action
  go = n => {
    this.history.go(n);
  };

  @action
  goBack = () => {
    this.history.goBack();
  };

  @action
  goForward = () => {
    this.history.goForward();
  };
}

const routerStore = new RouterStore();

export default routerStore;
